import React from "react";
import { Grid } from "@mui/material";
import "./reportHeader.scss";
import DownloadIcon from "@mui/icons-material/Download";
import { Button } from "@mui/material";
import { convertToLocalTime } from "../../../../../utils/helper";

const ReportHeader = ({
  headerData,
  handlePrint,
  logoCheck,
  disablePrint = false,
}) => {
  return (
    <>
      <div className="overReportHeader">
        <Grid container className="reportHeader">
          <Grid
            lg={3}
            md={3}
            sm={4}
            xs={12}
            className="reportHeaderCol reportIdCol"
          >
            <div className="reportTitle">
              Report ID: {headerData?.report_Id}
            </div>
          </Grid>
          <Grid
            lg={5}
            md={5}
            sm={8}
            xs={12}
            className="reportHeaderCol formNameCol"
          >
            <div className="inspectionFormName">
              Inspection Name: {headerData?.inspectionFormName ?? ""}
            </div>
          </Grid>
          <Grid lg={4} md={4} sm={12} xs={12} className="reportHeaderRight">
            <div className="hbLogo">
              <img src={logoCheck} alt="" />
            </div>
            <div className="reportDesc">
              Reported on:
              <span>{convertToLocalTime(headerData.conducted_On)}</span>
            </div>
            <Button
              onClick={handlePrint}
              disabled={disablePrint}
              variant="contained"
              startIcon={<DownloadIcon className="downloadIcon" />}
              className="downloadpdf"
            >
              View PDF
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default ReportHeader;
